import WarningAmber from '@mui/icons-material/WarningAmber';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import { Trans, useTranslation } from 'react-i18next';

import { StaticNotification } from 'library/models/Alert';

interface StaticNotificationAlertProps {
	notification: StaticNotification | null;
}

export const StaticNotificationAlert = ({
	notification,
}: StaticNotificationAlertProps): React.JSX.Element | null => {
	const { t } = useTranslation();
	const theme = useTheme();
	if (!notification) {
		return <></>;
	}

	const { message, severity, transKey } = notification;
	return (
		<Alert
			iconMapping={{ error: <WarningAmber /> }}
			severity={severity || 'info'}
			sx={{
				alignItems: 'center',
				pt: 1,
				pb: 1,
				pl: 2,
				pr: 2,
				fontSize: theme.typography.h6.fontSize,
			}}>
			{transKey ? <Trans t={t} i18nKey={transKey} /> : message}
		</Alert>
	);
};
